import { ReactNode, useCallback, useMemo, useState } from 'react';

import { LayoutPaddingContext } from './layoutPadding.context';
import { LayoutPaddingContextType } from './layoutPadding.types';

export const LayoutPaddingContextProvider = ({
  children,
}: {
  children?: ReactNode;
}): JSX.Element => {
  const [isPaddingDisabled, setIsPaddingDisabled] = useState(false);

  const setPaddingDisabled = useCallback((disabled: boolean) => {
    setIsPaddingDisabled(disabled);
  }, []);

  const contextValue: LayoutPaddingContextType = useMemo(
    () => ({ isPaddingDisabled, setPaddingDisabled }),
    [isPaddingDisabled, setPaddingDisabled]
  );

  return (
    <LayoutPaddingContext.Provider value={contextValue}>
      {children}
    </LayoutPaddingContext.Provider>
  );
};
